import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Users, Gift, ArrowRight } from "lucide-react";

export const ReferralPromo = () => (
  <section className="relative py-24 sm:py-32 border-y border-white/5 bg-[#070707] overflow-hidden" data-testid="referral-promo-section">
    <div
      className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] pointer-events-none"
      style={{ background: "radial-gradient(ellipse at top, rgba(255,94,0,0.08), transparent 65%)" }}
    />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10% 0px" }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-orange-500 font-bold tracking-[0.3em] text-xs uppercase mb-4 slash">
            Referral Program
          </p>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.95] mb-6"
            style={{ fontFamily: "'Orbitron', sans-serif" }}
          >
            Send a Friend,
            <br />
            <span className="text-orange-500">Get a Free Tweak.</span>
          </h2>
          <p className="text-zinc-400 text-base sm:text-lg leading-relaxed mb-8 max-w-xl">
            Get your own code, share it, and earn a point every time someone buys using it —
            no matter which plan they pick. Trade points in for free tweaks, unlocked instantly
            in the desktop app.
          </p>
          <Link
            to="/referral"
            className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-400 text-black font-black uppercase tracking-[0.2em] text-xs px-8 py-4 transition-all hover:shadow-[0_0_30px_rgba(255,94,0,0.5)]"
            data-testid="referral-promo-cta"
          >
            Get My Code <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10% 0px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="grid grid-cols-2 gap-4"
        >
          <div className="glass !rounded-2xl p-6 flex flex-col items-start">
            <div className="w-12 h-12 glass !rounded-xl flex items-center justify-center mb-4">
              <Users className="w-5 h-5 text-orange-500" />
            </div>
            <p className="text-3xl font-black" style={{ fontFamily: "'Orbitron', sans-serif" }}>
              1 point
            </p>
            <p className="text-zinc-500 text-xs uppercase tracking-widest mt-1">Free Console Tweak</p>
          </div>
          <div className="glass !rounded-2xl p-6 flex flex-col items-start" style={{ borderColor: "rgba(255,94,0,0.3)" }}>
            <div className="w-12 h-12 glass !rounded-xl flex items-center justify-center mb-4">
              <Gift className="w-5 h-5 text-orange-500" />
            </div>
            <p className="text-3xl font-black text-orange-500" style={{ fontFamily: "'Orbitron', sans-serif" }}>
              3 points
            </p>
            <p className="text-zinc-500 text-xs uppercase tracking-widest mt-1">Free PC Tweak</p>
          </div>
          <div className="col-span-2 glass !rounded-2xl p-5">
            <p className="text-zinc-400 text-sm">
              Earn 1 point for every friend who buys — console, PC, doesn&apos;t matter.
              No cap, no expiration on your code.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
